export const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
export const mockApiUrl = 'https://61aa7860bfb110001773f262.mockapi.io/api/v1/devices';
export const socketUrl = process.env.REACT_APP_WEBSOCKET_URL;